import React from 'react';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Mentions légales</h1>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Éditeur du site</h2>
          <p className="text-gray-600">
            <strong>MRTP SARL</strong><br />
            5 Lot. Côte Meunière<br />
            04370 Villars-Colmars, France<br />
            Email : <a href="mailto:Contact@artduchalet.com" className="text-[#c4d600]">Contact@artduchalet.com</a>
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Responsable de publication</h2>
          <p className="text-gray-600">
            La direction de MRTP SARL assure la responsabilité éditoriale du site, ainsi que la mise à jour des
            contenus, dans le respect de l&rsquo;image et des valeurs de l&rsquo;entreprise.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Hébergement</h2>
          <p className="text-gray-600">
            Le site est hébergé par notre prestataire spécialisé en infrastructures cloud sécurisées. Les serveurs
            sont géographiquement situés dans l&rsquo;Union Européenne, garantissant la conformité avec le RGPD.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Propriété intellectuelle</h2>
          <p className="text-gray-600">
            L&rsquo;ensemble des contenus (textes, visuels, graphismes, logos) présents sur ce site est protégé par le
            Code de la propriété intellectuelle. Toute reproduction ou diffusion sans autorisation écrite de MRTP SARL
            est strictement interdite.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Crédits</h2>
          <p className="text-gray-600">
            Conception et réalisation : MRTP SARL.<br />
            Photographies : banques d&rsquo;images libres de droits et collections propriétaires.
          </p>
        </section>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;

